// extracted by mini-css-extract-plugin
module.exports = {"textContainer":"MultilineText_textContainer__2gdTN"};